const VISA_START_PATTERN = /^4/;
const MASTERCARD_START_PATTERN = /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/;
const DISCOVER_START_PATTERN = /^(6011|65|64[4-9]|622)/;

export type CardType = {
  displayName: string;
  type: string;
  startPattern: RegExp;
};

const CARD_TYPES: Array<CardType> = [
  {
    displayName: 'Visa',
    type: 'visa',
    startPattern: VISA_START_PATTERN,
  },
  {
    displayName: 'Mastercard',
    type: 'mastercard',
    startPattern: MASTERCARD_START_PATTERN,
  },
  {
    displayName: 'Discover',
    type: 'discover',
    startPattern: DISCOVER_START_PATTERN,
  },
];

export const getCardVendor = (value: string): CardType =>
  CARD_TYPES.find(cardType => cardType.startPattern.test(value));

export const UNKNOWN_CARD_TYPE = {
  displayName: 'Debit Card',
  type: 'unknown',
};
